import {Component, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'retail',
    templateUrl: './retail.component.html'
})
export class RetailComponent implements OnInit {

    constructor(@Inject(DOCUMENT) public document: Document) {
    }

    ngOnInit(): void {
    }
}
